// Mixin to provide ECharts theme based on app skin
export default {
  computed: {
    echartsTheme() {
      const skin = this.$store.state.appConfig.layout.skin
      return skin === 'dark' ? 'dark' : ''
    },
  },
}
